namespace GeniuzPOS.Purchase {
    export interface PoPo05DtPendingPIforIrForm {
    }

    export class PoPo05DtPendingPIforIrForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPo05DtPendingPIforIr';
    }
}
